module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-main', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "#3F3FFF"
    }
  }, [_c('v-toolbar-title', [_vm._v("Instagram Pages")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c('v-list', [_c('v-radio-group', {
    attrs: {
      "mandatory": true,
      "name": "list-ig"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_vm._l((_vm.facebookData), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-action', [_c('v-radio', {
      attrs: {
        "value": item.id
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
      attrs: {
        "href": ""
      }
    }, [_vm._v("@" + _vm._s(item.username))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.followers_count) + " followers")])], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": item.profile_picture_url
      }
    })])], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.selected,
      "color": "secondary"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Next")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-066c9e78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectInstagram.vue
// module id = 1982
// module chunks = 0